import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "@app/modules/alert";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { BaseService } from "./base.service";

@Injectable({
    providedIn: "root",
})
export class OrgDataService extends BaseService  {
 
    url = this.getBaseURL() + "org";

    errorOptions = {
        autoClose: false,
        keepAfterRouteChange: false,
    };
    constructor(private http: HttpClient, private alertService: AlertService) {
        super();
    }

    getDepartments() {
        const url = this.url + "/departments";       
        
       
        return this.http.get<string[]>(url, {headers: this.setCustomRequestheaders()}).pipe(
            catchError(
                (error): Observable<unknown> => {

                    this.alertService.error(
                        "Error loading data from database : " +
                            this.checkStatusCode(error),
                        this.errorOptions
                    );
                    throw error;
                }
            )
        );
    }
    
    
}
